import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests.js';
import { dateToString } from '../../shared/utils/parseDate.js';
import { Pagination } from '../../features/Pagination/index.js';
import { useUrlPagination } from '../../shared/hooks/useUrlPagination.js';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';
import { EmptyState } from '../../shared/ui/EmptyState';
import { Plus, Tags } from 'lucide-react';

const PAGE_SIZE = 5;

const CategoriesOfEventsPage = () => {
  const [data, setData] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();
  const q = searchParams.get('q') || '';
  const [searchValue, setSearchValue] = useState(q);
  const [reloadKey, setReloadKey] = useState(0);
  const { page, offset, pageSize, setPage } = useUrlPagination(PAGE_SIZE);

  // Черновик в поле поиска следует за URL (назад/вперёд в браузере)
  useEffect(() => {
    setSearchValue(q);
  }, [q]);

  useEffect(() => {
    let cancelled = false;
    const request = q
      ? apiRequests.events.getCategoriesFiltered(q, pageSize, offset)
      : apiRequests.events.getCategories(pageSize, offset);
    request
      .then((res) => {
        if (!cancelled) setData(res);
      })
      .catch((e) => console.error(e));
    return () => {
      cancelled = true;
    };
  }, [q, offset, pageSize, reloadKey]);

  const handleSearch = () => {
    const next = searchValue.trim();
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      if (next) params.set('q', next);
      else params.delete('q');
      params.delete('page');
      return params;
    });
  };

  const handleDelete = (id) => {
    apiRequests.events.deleteCategory(id).then(() => {
      if (data.items?.length === 1 && page > 1) setPage(page - 1);
      else setReloadKey((k) => k + 1);
    });
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск категорий..."
        createLink="/events/categories/create"
      />

      <div className="mb-3">
        {data.items?.length === 0 ? (
          q ? (
            <EmptyState
              icon={Tags}
              variant="search"
              title="Категория не найдена"
              description={`По запросу «${q}» категорий нет. Проверьте написание или создайте новую.`}
            />
          ) : (
            <EmptyState
              icon={Tags}
              title="Категорий пока нет"
              description="Категории делят мероприятия по темам — например, «Конференции» или «Хакатоны». Без категории событие не создать."
              action={{ label: 'Добавить категорию', to: '/events/categories/create', icon: Plus }}
            />
          )
        ) : (
          data.items?.map((item) => (
            <EntityCard
              key={item.id}
              title={item.title}
              fields={[{ label: 'Создано', value: dateToString(item.createdAt) }]}
              editLink={`/events/categories/${item.id}`}
              onDelete={() => handleDelete(item.id)}
            />
          ))
        )}
      </div>

      <Pagination page={page} total={data.totalCount} pageSize={pageSize} onPageChange={setPage} />
    </>
  );
};

export default CategoriesOfEventsPage;
